import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export type SaveCustomClassTypeEndpointRequest = {
  id?: string
  name: string
  planPeriodId: string
}

const saveCustomClassTypeEndpoint = (request: SaveCustomClassTypeEndpointRequest) => {
  return adminHttpClient.post('/SaveCustomClassTypeEndpoint', request)
}

export default saveCustomClassTypeEndpoint
